<template>
  <div class="PWR01G01">
    <div class="title_h1">作業予定</div>
    <vab-query-form
      ref="queryForm"
      :model="queryForm"
      :rules="rules"
      size="mini"
      label-width="98px"
      @search="fetchData"
      @cancel="cancelSet"
    >
      <vab-row :gutter="24">
        <WorkYmFromTo></WorkYmFromTo>
        <vab-col :lg="8" :xl="8" :md="12">
          <el-form-item class="big_label_110" label="予定日">
            <el-row>
              <el-col :span="24" class="searchdateinputrow">
                <vab-input
                  type="number"
                  :zero="false"
                  prop="planWorkStartDate"
                  class="searchdateinput"
                  maxlength="2"
                  :disabled="workYmlimit"
                  @change="setStartDate()"
                  @blur="blurTimeFrom"
                />
                <div class="searchdateinputsplit">日</div>
                <div class="space">〜</div>
                <vab-input
                  type="number"
                  :zero="false"
                  prop="planWorkEndDate"
                  class="searchdateinput"
                  maxlength="2"
                  :disabled="workYmlimit"
                  @change="setEndDate()"
                  @blur="blurTimeTo"
                />
                <div class="searchdateinputsplit">日</div>
              </el-col>
            </el-row>
          </el-form-item>
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <el-row type="flex">
            <el-col :span="24">
              <vab-input label="建物" prop="blgsnmkj" />
            </el-col>
          </el-row>
        </vab-col>
        <!-- 商品明細 -->
        <vab-col :lg="8" :xl="8" :md="12">
          <MitmdtlpNew
            ref="itemDetailCdRef"
            prop="itemDetailCd"
            :componentcd.sync="queryForm.itemDetailCd"
            :span1="7"
            :span2="17"
            :multi-select="false"
            :clear-validate="true"
            @clearOtherData="clearOtherData"
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            ref="workSpecRef"
            label="点検仕様"
            prop="workSpecCdList"
            :data-items="workSpecCdList"
            label-id="itmgkmnm"
            value-id="itmgkmcd"
            collapse-tags
            :disabled="workSpecCdDisabled"
            placeholder=""
            clearable
            multiple
          />
        </vab-col>
        <vab-collapse title="詳細検索を表示">
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-select
              ref="groupRef"
              label="グループ"
              prop="groupList"
              filter="groupValue"
              placeholder="選択されていません"
              multiple
              clearable
              collapse-tags
            />
          </vab-col>
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-select
              ref="changeStatusSelect"
              label="ステータス"
              placeholder="選択されていません"
              prop="changeStatusList"
              filter="wparStatus"
              clearable
              multiple
              collapse-tags
            />
          </vab-col>
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-select
              label="日程調整不要"
              prop="adjustUnnecessaryFlg"
              :data-items="adjustUnnecessaryFlg"
              label-id="text"
              value-id="value"
            />
          </vab-col>
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-select
              label="削除済みデータ"
              prop="changeFlg"
              filter="deletedContainFlag"
              class="label_height"
            />
          </vab-col>
        </vab-collapse>
      </vab-row>
    </vab-query-form>
    <vab-form ref="form" :model="form" :rules="rulesTable">
      <vab-table
        ref="table"
        api-url="/api/workingPlanAndResultRc/queryList"
        :columns="columns"
        :nav-buttons="navButtons"
        :right-buttons="rightButtons"
        :query-params="{
          ...setQueryParams(queryForm),
          sidx: 'workNo,workingPlanAndResultRcId',
          sort: 'desc,desc',
        }"
        :span="12"
        :enable-init="reloadPage"
        :submit-mode="true"
        :init-params="{
          ...queryForm,
          sidx: 'workNo,workingPlanAndResultRcId',
          sort: 'desc,desc',
        }"
        primary-key="workingPlanAndResultRcId"
        :row-key="'workingPlanAndResultRcId'"
        :row-class-name="
          ({ row, rowIndex }) =>
            rowClassName(
              row,
              rowIndex,
              'workingPlanAndResultRcId',
              multipleSelection
            )
        "
        :selec-table-switch="true"
        :multi-select="true"
        class="table_work"
        @submitTable="submitTable"
        @select="selectionChange"
        @select-all="handleSelectAll"
        @select-table="selectable"
      >
        <template #fixedTime="{ row, index }">
          <el-row class="flex_center_align el_row_box vab_time time_50">
            <vab-time
              :week-show="true"
              :disabled="timeDisabled(row) || deadlineDisabled(row)"
              :ym="queryForm.workYm"
              :row-item="row"
              class="time13"
              :prop="'tableList.' + index + '.workPlanDateDay'"
              @svgClick="openDay(row, index)"
              @change="timeReset($event, index)"
            />
            <vab-time-input
              v-model="row.workPlanStartTime"
              label-error="予定日時"
              :disabled="
                timeDisabled(row) ||
                deadlineDisabled(row) ||
                $baseLodash.isEmpty(row.workPlanDateDay)
              "
              :row-item="row"
              :validate="vaildateTimeStart(row, index)"
              :prop="'tableList.' + index + '.workPlanStartTime'"
              class="time13"
            />
            <div class="mg8">〜</div>
            <vab-time-input
              v-model="row.workPlanEndTime"
              label-error="予定日時"
              :disabled="
                timeDisabled(row) ||
                deadlineDisabled(row) ||
                $baseLodash.isEmpty(row.workPlanDateDay)
              "
              :row-item="row"
              :validate="vaildateTimeEnd(row, index)"
              :prop="'tableList.' + index + '.workPlanEndTime'"
              class="time13"
            />
          </el-row>
        </template>
        <template #blgsnmkj="{ row }">
          <div class="blgsnmkj_class">
            <svg-icon
              class="svg_icon"
              icon-class="select_work"
              @click="openBlgsnmkj(row)"
            />
            <el-link type="primary" @click="openBlgsnmkj(row)">
              {{ getFieldValue('blgsnmkj', row) }}
            </el-link>
          </div>
        </template>
        <template #dateLimitContent="{ row }">
          <div class="flex_colum">
            <div class="pre_wrap">
              {{
                getFieldValue(
                  'dateLimitContentCanText',
                  row.weekdayConditionSpecify
                )
              }}
            </div>
            <div>
              {{
                getFieldValue(
                  'dateLimitContentCannotText',
                  row.weekdayConditionSpecify
                )
              }}
            </div>
          </div>
        </template>
      </vab-table>
    </vab-form>
    <div class="flex_space mg12">
      <vab-button :btn-list="makeList" />
      <div class="flex_end">
        <vab-button :btn-list="btnUpdate" />
      </div>
    </div>
    <ScheduledDatesPopup
      :visible2="visivleScheduled"
      :visible-children.sync="visivleScheduled"
    />
    <fixedTime ref="fixedTime" @saveData="saveData" />
    <Buildings ref="building" />
  </div>
</template>

<script lang="jsx">
  import {
    updateWorkPlanInput,
    queryBuildingInformation,
    getFoundSelfData,
  } from '@/api/rc/jobReservation'
  import { setTableCellValue } from '@/utils/index'
  import reload from '@/utils/reload'
  export default {
    name: 'PWR01G01',
    extends: reload,
    data() {
      return {
        workSpecCdDisabled: true,
        workSpecCdList: [],
        visivleScheduled: false,
        list: [
          {
            switch: false,
          },
        ],
        form: {
          tableList: [],
        },
        rulesObj: {},
        rules: {},
        rulesTable: {},
        queryForm: {
          planWorkStartDate: null,
          planWorkEndDate: null,
          itemDetailCd: null,
          adjustUnnecessaryFlg: '0',
          changeFlg: this.$divisions.deletedContainFlagEnum.enum_0.value,
          changeStatusList: [],
          workYm: null,
          workYmTo: null,
        },
        goodsLists: [],
        columns: [
          {
            label: '入力期限',
            'min-width': 140,
            fixed: 'left',
            sortable: false,
            prop: 'answerDeadline',
          },
          {
            label: '作業年月',
            'min-width': 120,
            fixed: 'left',
            sortable: true,
            prop: 'workYm',
            formatter: (row) => {
              if (row.workYm) {
                return this.$dayjs(row.workYm.toString()).format('YYYY/MM')
              }
            },
          },
          {
            label: '予定日時',
            'min-width': 302,
            fixed: 'left',
            sortable: false,
            slotScope: 'fixedTime',
          },
          {
            label: '建物CD',
            'min-width': 120,
            prop: 'workingPlanAndResultIdModel.buildingCd',
          },
          {
            label: '建物',
            'min-width': 240,
            sortable: false,
            slotScope: 'blgsnmkj',
          },
          {
            label: '商品明細CD',
            'min-width': 120,
            prop: 'workingPlanAndResultIdModel.itemDetailCd',
          },
          {
            label: '商品明細',
            'min-width': 140,
            prop: 'itmdtlnm',
          },
          {
            label: '点検仕様',
            'min-width': 160,
            prop: 'workingPlanAndResultIdModel.workSpecName',
          },
          {
            label: '条件・コメント',
            'min-width': 850,
            sortable: false,
            prop: 'weekdayConditionSpecify.conditionText',
          },
          {
            label: '発注コメント',
            'min-width': 240,
            prop: 'workingPlanAndResultIdModel.purchaseOrderDetailComment',
          },
          {
            label: '作業回別コメント',
            'min-width': 240,
            sortable: false,
            prop: 'workTimesComment',
          },
          {
            label: '作業No',
            'min-width': 140,
            prop: 'workingPlanAndResultIdModel.workNo',
          },
          {
            label: '発注NO連番',
            'min-width': 140,
            prop: 'purchaseOrderDetailRcIdModel.purchaseOrderDetailIdModel.acceptOrderNoSeq',
          },
          {
            label: '発注部門',
            'min-width': 240,
            sortable: false,
            prop: 'purchaseOrderDepName',
          },
          {
            label: '発注担当者',
            'min-width': 120,
            sortable: false,
            prop: 'purchaseOrderPersonName',
          },
          {
            label: 'ステータス',
            'min-width': 140,
            prop: 'changeStatus',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(cellValue, this.$divisions.wparStatusEnum)
            },
          },
          {
            label: '管理形態',
            'min-width': 140,
            prop: 'mngfrm',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(cellValue, this.$divisions.manageFormEnum)
            },
          },
          {
            label: '月間回数',
            'min-width': 100,
            prop: 'purchaseOrderDetailRcIdModel.monthFreq',
          },
          {
            label: 'グループ',
            'min-width': 120,
            prop: 'purchaseOrderDetailRcIdModel.groupValue',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(cellValue, this.$divisions.groupValueEnum)
            },
          },
          {
            // 按钮
            type: 'actions',
            label: '操作',
            fixed: 'right',
            disableCheck: true,
            actions: [
              {
                name: '作業日程変更',
                type: 'text',
                show: (row) => {
                  return (
                    (([
                      this.$divisions.wparStatusEnum.enum_02.value,
                      this.$divisions.wparStatusEnum.enum_03.value,
                      this.$divisions.wparStatusEnum.enum_04.value,
                    ].includes(row.changeStatus) &&
                      [
                        this.$divisions.changeRequestFlgEnum.enum_1.value,
                        this.$divisions.changeRequestFlgEnum.enum_2.value,
                        this.$divisions.changeRequestFlgEnum.enum_3.value,
                        this.$divisions.changeRequestFlgEnum.enum_4.value,
                      ].includes(row.changeRequestFlg)) ||
                      [
                        this.$divisions.wparStatusEnum.enum_07.value,
                        this.$divisions.wparStatusEnum.enum_08.value,
                        this.$divisions.wparStatusEnum.enum_09.value,
                      ].includes(row.changeStatus)) &&
                    !this.isEqualCodeEnum(
                      row.changeFlg,
                      this.$divisions.changeFlgEnum.enum_3
                    ) &&
                    this.$baseLodash.isEmpty(
                      row.workingPlanAndResultIdModel.workCancelDate
                    )
                  )
                },
                click: (row) => {
                  this.$routerPush({
                    name: 'PWR01G04',
                    query: { rcIds: row.workingPlanAndResultRcId },
                  })
                },
              },
              {
                name: '作業日程詳細',
                type: 'text',
                click: (row) => {
                  this.$routerPush({
                    name: 'PWR01G03',
                    query: {
                      purchaseOrderDetailRcId: row.purchaseOrderDetailRcId,
                      fromRoute: this.$route.name,
                    },
                  })
                },
              },
            ],
          },
        ],
        navButtons: [
          {
            name: '日程変更依頼',
            disabled: true,
            plain: true,
            type: 'primary',
            weight: '500',
            hidden: false,
            click: () => {
              this.multipleChange()
            },
          },
          {
            type: 'slot',
            hidden: false,
            render: () => {
              return (
                <div class="tzx_box">
                  <el-dropdown
                    on={{
                      command: (command) => {
                        this.handleCommand(command)
                      },
                    }}
                  >
                    <div class="upload_btn_box icon btn_dropdown margin_top_0 background_f">
                      作業予定記入表
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-blur-on-click command="output">
                        ダウンロード
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <vab-upload
                          ref="estimateBreakdownDetailRef"
                          upload-url="/api/workingPlanAndResultRc/uploadWorkPlanInputList"
                          showSvg={false}
                          errorExport={true}
                          isExcel={true}
                          onOn-success={() => {
                            this.msgSuccess(
                              this.$t(
                                `validateMessage.${this.$messageCode.I00000429.name}`
                              )
                            )
                            this.fetchData()
                          }}
                        ></vab-upload>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              )
            },
          },
          {
            name: ' 作業確認表＆見積条件書ダウンロード',
            type: 'hollow',
            svg: 'down_work',
            hover: '#0071EE',
            defaultColor: '#ffffff',
            weight: '500',
            hidden: false,
            click: () => {
              this.confirmationFormDL()
            },
          },
        ],
        rightButtons: [
          {
            type: 'slot',
            hidden: false,
            render: () => {
              return (
                <div
                  class="tzx_box right_btn_text"
                  on={{
                    click: (command) => {
                      this.goNote(command)
                    },
                  }}
                >
                  <svg-icon icon-class="transfer_3_line" class="transfer_svg" />
                  <span>発注詳細に切り替え</span>
                </div>
              )
            },
          },
        ],
        makeList: [
          {
            name: 'Excel出力',
            icon: 'xls_fill',
            type: 'plain',
            hidden: false,
            defaultColor: '#0060C2',
            click: this.handleDownload,
          },
        ],
        btnUpdate: [
          {
            name: '更新',
            icon: 'check_line',
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000409.name}`
            ),
            type: 'button',
            hidden: false,
            disabled: true,
            click: () => {
              this.$refs['form'].validate((valid) => {
                if (valid) {
                  this.$confirm({
                    msg: this.format(
                      this.$t(
                        `validateMessage.${this.$messageCode.I00000301.name}`
                      ),
                      '更新'
                    ),
                    yesTex: '更新',
                    yes: async () => {
                      this.update()
                    },
                  })
                } else {
                  return false
                }
              })
            },
          },
        ],
        selectList: [],
        num: null,
        adjustUnnecessaryFlg: [
          {
            code: this.$divisions.unnecessaryFlagEnum.enum_1,
            value: '0',
            text: '日程調整不要を含まない',
          },
          {
            code: this.$divisions.unnecessaryFlagEnum.enum_blank,
            value: '1',
            text: '日程調整不要を含む',
          },
        ],
        initTableList: [],
        multipleSelection: [],
      }
    },
    computed: {
      searchData() {
        return this.$store.getters['notify/searchData']
      },
      vaildateTimeStart() {
        return (row, index) => {
          if (
            !(
              this.timeDisabled(row) ||
              this.deadlineDisabled(row) ||
              this.$baseLodash.isEmpty(row.workPlanDateDay)
            )
          ) {
            this.$set(this.rulesTable, `tableList.${index}.workPlanStartTime`, [
              {
                required: true,
                message: this.format(
                  this.$t(
                    `validateMessage.${this.$messageCode.E00000001.name}`
                  ),
                  '予定日時'
                ),
                trigger: 'blur',
              },
            ])
          } else {
            this.$set(this.rulesTable, `tableList.${index}.workPlanStartTime`, [
              {
                required: false,
                message: null,
              },
            ])
          }
        }
      },
      vaildateTimeEnd() {
        return (row, index) => {
          if (
            !(
              this.timeDisabled(row) ||
              this.deadlineDisabled(row) ||
              this.$baseLodash.isEmpty(row.workPlanDateDay)
            )
          ) {
            this.$set(this.rulesTable, `tableList.${index}.workPlanEndTime`, [
              {
                required: true,
                message: this.format(
                  this.$t(
                    `validateMessage.${this.$messageCode.E00000001.name}`
                  ),
                  '予定日時'
                ),
                trigger: 'blur',
              },
            ])
          } else {
            this.$set(this.rulesTable, `tableList.${index}.workPlanEndTime`, [
              {
                required: false,
                message: null,
              },
            ])
          }
        }
      },
      workYmlimit: {
        get() {
          if (
            !this.$baseLodash.isEmpty(this.queryForm.workYm) &&
            !this.$baseLodash.isEmpty(this.queryForm.workYmTo) &&
            this.$dayjs(this.queryForm.workYm).isSame(
              this.queryForm.workYmTo,
              'month'
            )
          ) {
            return false
          } else {
            return true
          }
        },
        set(val) {
          return val
        },
      },
    },
    watch: {
      async 'queryForm.itemDetailCd'(list) {
        if (this.$baseLodash.isEmpty(list)) {
          this.workSpecCdDisabled = true
        } else {
          this.workSpecCdDisabled = false
          this.workSpecCdList = await getFoundSelfData({
            itmdtlcd: list,
          })
        }
      },
      workYmlimit: {
        handler(val) {
          if (val) {
            this.queryForm.planWorkStartDate = null
            this.queryForm.planWorkEndDate = null
          }
        },
        immediate: true,
      },
    },
    beforeDestroy() {
      let data = JSON.parse(this.searchData)
      if (!this.$baseLodash.isEmpty(data) && data[this.$route.name]) {
        data[this.$route.name] = []
        this.$store.dispatch('notify/setPageSearchData', JSON.stringify(data))
      }
    },

    mounted() {
      this.getChangeStatusList()
      if (!this.$route?.query?.top) {
        this.queryForm.workYm = this.$dayjs().format('YYYYMM')
        this.queryForm.workYmTo = this.$dayjs().format('YYYYMM')
      }
      this.$nextTick(() => {
        this.$refs.table.setVm(this)
        if (this.$route?.query?.goNote === '1') {
          this.$refs['queryForm'].cancel()
          if (this.$baseLodash.isEmpty(this.queryForm.workYm)) {
            this.queryForm.workYm = this.$dayjs().format('YYYYMM')
          }
          if (this.$baseLodash.isEmpty(this.queryForm.workYmTo)) {
            this.queryForm.workYmTo = this.$dayjs().format('YYYYMM')
          }
          this.initQuery()
          this.queryForm.workYmTo = this.queryForm.workYm
        }
      })
    },
    created() {
      this.$baseEventBus.$on('uscs', () => {
        this.success()
      })
    },
    methods: {
      success() {
        this.fetchData()
      },
      // 伝参賦値です
      initQuery() {
        let data = JSON.parse(this.searchData)
        if (!this.$baseLodash.isEmpty(data)) {
          if (data[this.$route.name]?.length > 0) {
            data[this.$route.name].forEach((itm) => {
              itm.prop = itm.prop === 'workYmForm' ? 'workYm' : itm.prop
            })
            this.setFormDataList(
              data[this.$route.name],
              this.$refs['queryForm']
            )
          }
        }
      },
      // 商品明細
      clearOtherData() {
        this.$refs.workSpecRef.setValue([])
        this.queryForm.workSpecCdList = []
      },
      // tableチェックボックスです。
      selectable({ row }) {
        if (
          this.isEqualCodeEnum(
            row?.changeStatus,
            this.$divisions.wparStatusEnum.enum_08
          ) &&
          !this.isEqualCodeEnum(
            row?.changeCategory,
            this.$divisions.changeCategoryEnum.enum_1
          )
        ) {
          return true
        } else {
          return false
        }
      },
      submitTable(data) {
        this.$refs.form.clearValidate()
        this.changeTableList(data)
        // 前回の初期化データ
        let oldInitTableList = this.$baseLodash.cloneDeep(this.initTableList)
        // 現在のページングデータ
        this.initTableList = this.$baseLodash.cloneDeep(data.dataSource)

        let targetList = this.$baseLodash.cloneDeep(this.form.tableList)

        this.form.tableList = data.dataSource
        // 登録
        if (data.sort) return
        this.update(true, targetList, oldInitTableList)
      },
      // データを提出する
      update(
        flag = false,
        list = this.$refs.table.dataSource,
        originArr = this.initTableList
      ) {
        let updateList = this.getSubmitList(list, originArr)
        if (flag) {
          if (updateList.length == 0) return
          let errorList = []
          updateList.forEach((item) => {
            if (
              !item.disabled &&
              item.workPlanDateDay &&
              (!item.workPlanStartTime || !item.workPlanEndTime)
            ) {
              errorList.push(item)
            }
          })
          updateList = this.$baseLodash.difference(updateList, errorList)
          if (updateList.length == 0) return
          let msg = ''
          if (errorList.length > 0) {
            msg = this.$t(`validateMessage.${this.$messageCode.I00000439.name}`)
          } else {
            msg = this.$t(`validateMessage.${this.$messageCode.I00000408.name}`)
          }
          this.$confirm({
            msg: msg,
            yesText: '確定',
            yes: () => {
              return this.submitForm(updateList)
            },
            no: () => {
              return false
            },
          })
        } else {
          this.submitForm(updateList)
        }
      },
      // 時間無効です
      timeDisabled(row) {
        return !(
          [
            this.$divisions.wparStatusEnum.enum_02.value,
            this.$divisions.wparStatusEnum.enum_03.value,
            this.$divisions.wparStatusEnum.enum_04.value,
            this.$divisions.wparStatusEnum.enum_05.value,
          ].includes(row.changeStatus) &&
          this.isEqualCodeEnum(
            row.changeRequestFlg,
            this.$divisions.changeRequestFlgEnum.enum_blank
          )
        )
      },
      // 時間無効です
      deadlineDisabled(row) {
        return row.deadline ? !this.$dayjs().isBefore(row.deadline) : false
      },
      // リセット時間です
      timeReset(val, index) {
        if (!val) {
          // this.$refs.table.dataSource[index].workPlanDateDay = null
          // this.$refs.table.dataSource[index].workPlanStartTime = null
          // this.$refs.table.dataSource[index].workPlanEndTime = null

          // this.form.tableList[index].workPlanDateDay = null
          // this.form.tableList[index].workPlanStartTime = null
          // this.form.tableList[index].workPlanEndTime = null

          let data = {
            workPlanDateDay: null,
            workPlanStartTime: null,
            workPlanEndTime: null,
          }
          setTableCellValue(this.form.tableList, index, data)
          setTableCellValue(this.$refs.table.dataSource, index, data)
        }
      },
      // 予定日に保存します
      saveData(val) {
        if (!val) return

        let data = {
          workPlanDateDay: val?.day,
          workPlanStartTime: val?.startTime,
          workPlanEndTime: val?.endTime,
        }
        setTableCellValue(this.form.tableList, this.num, data)
        setTableCellValue(this.$refs.table.dataSource, this.num, data)

        // this.$refs.table.dataSource[this.num].workPlanDateDay = val?.date
        // this.$refs.table.dataSource[this.num].workPlanStartTime = val?.startTime
        // this.$refs.table.dataSource[this.num].workPlanEndTime = val?.endTime

        // this.form.tableList[this.num].workPlanDateDay = val?.date
        // this.form.tableList[this.num].workPlanStartTime = val?.startTime
        // this.form.tableList[this.num].workPlanEndTime = val?.endTime
      },
      //作業日程の変更--複数選択
      multipleChange() {
        let rcIdsList = []
        this.selectList.forEach((item) => {
          rcIdsList.push(item.workingPlanAndResultRcId)
        })
        const rcIds = rcIdsList.join(',')
        this.$routerPush({
          name: 'PWR01G04',
          query: { rcIds: rcIds },
        })
      },
      // 全て選択
      handleSelectAll(val) {
        this.selectionChange(val)
      },
      // 選択した表データを取得します
      selectionChange(val) {
        this.multipleSelection = val
        if (val.length > 0) {
          this.navButtons.filter((item) => {
            item.disabled = false
          })
        } else {
          this.navButtons.filter((item) => {
            item.disabled = true
          })
        }
        this.selectList = val
      },
      // プルダウン選択ボックスです
      handleCommand(command) {
        switch (command) {
          case 'output':
            this.outputWorkPlanInput()
            break
          case 'upload':
            this.personalCenter()
            break
        }
      },
      // ルーティング・トランジション
      goNote() {
        if (this.workYmVerify()) return
        let formJson = this.getSearchJson(this.$refs['queryForm'])
        let data = {}
        data['PWR01G02'] = formJson
        this.$store.dispatch('notify/setPageSearchData', JSON.stringify(data))
        this.$routerPush({
          name: 'PWR01G02',
          query: { goNote: '1' },
        })
      },
      changeTableList(data) {
        data.dataSource.forEach((itm) => {
          let start = itm.workPlanStartTime ?? ''
          let end = itm.workPlanEndTime ?? ''
          itm.workPlanStartTime = start !== '' ? start.slice(0, 5) : null
          itm.workPlanEndTime = end !== '' ? end.slice(0, 5) : null
        })
      },
      // 検索ボタン
      fetchData() {
        if (this.$baseLodash.isEmpty(this.queryForm.workYm)) {
          this.queryForm.workYm = this.$dayjs().format('YYYYMM')
        }
        if (this.$baseLodash.isEmpty(this.queryForm.workYmTo)) {
          this.queryForm.workYmTo = this.$dayjs().format('YYYYMM')
        }
        this.$nextTick(() => {
          this.$refs.table.fetchData().then(() => {
            this.changeTableList({
              dataSource: this.$refs.table.dataSource,
            })
            this.$refs.table.clearSelection()
            this.selectList = []
            this.navButtons.filter((item) => {
              item.disabled = true
            })
            this.initTableList = this.$baseLodash.cloneDeep(
              this.$refs.table.dataSource
            )
            this.$nextTick(() => {
              this.$set(
                this.form,
                'tableList',
                this.$baseLodash.cloneDeep(this.$refs.table.dataSource)
              )
            })
          })
        })
      },
      // クリア
      cancelSet() {
        this.$set(this.queryForm, 'adjustUnnecessaryFlg', '0')
        this.$set(this.queryForm, 'changeFlg', '0')
      },
      // 商品明細
      getGoodList(val) {
        const { data } = val
        this.goodsLists = [...data]
      },
      // Excel出力
      handleDownload() {
        if (this.workYmVerify()) return
        this.downloadCommon.resource(
          '/api/workingPlanAndResultRc/excelOutput',
          this.setQueryParams(this.queryForm)
        )
      },
      //作業予定確認表DL
      confirmationFormDL() {
        if (this.workYmVerify()) return
        let data = {
          workYm: this.queryForm.workYm,
          workYmTo: this.queryForm.workYmTo,
        }
        this.downloadCommon.resource(
          '/api/workingPlanAndResultRc/outputWorkPlanConfirmList',
          data
          // this.$const.worksApiPre
        )
      },
      // 作業予定記入表DL
      outputWorkPlanInput() {
        if (this.workYmVerify()) return
        let data = {
          workYm: this.queryForm.workYm,
          workYmTo: this.queryForm.workYmTo,
        }
        this.downloadCommon.resource(
          '/api/workingPlanAndResultRc/outputWorkPlanInputList',
          data
        )
      },
      // (DLN側)作業予定一覧（作業日単位) 「登録」ボタンをクリック時
      async submitForm(data) {
        this.setTimeNull(data)
        let params = this.$baseLodash.cloneDeep(data)
        params.forEach((item) => {
          item.workPlanStartTime = this.formatTimeMsel(
            item.workPlanStartTime,
            'HH:mm:ss:sss'
          )
          item.workPlanEndTime = this.formatTimeMsel(
            item.workPlanEndTime,
            'HH:mm:ss:sss'
          )
        })
        this.$baseColorfullLoading()
        try {
          await updateWorkPlanInput(params)
          this.msgSuccess(
            this.$t(`validateMessage.${this.$messageCode.I00000409.name}`)
          )
          this.fetchData()
        } finally {
          this.$baseColorfullLoading().close()
        }
      },
      // 建物
      async openBlgsnmkj(row) {
        const dataObj = {
          buildingCd: row?.workingPlanAndResultIdModel?.buildingCd,
          sectionCd: row?.workingPlanAndResultIdModel?.sectionCd,
        }
        this.$baseColorfullLoading()
        try {
          const res = await queryBuildingInformation(dataObj)
          this.$refs.building.dataList = res
        } finally {
          this.$baseColorfullLoading().close()
        }
        this.$refs.building.visible = true
      },
      // 予定日時
      openDay(data, index) {
        if (this.timeDisabled(data)) return
        this.num = index
        let cloneData = this.$baseLodash.cloneDeep(data)
        cloneData = {
          ...cloneData,
          requestYearMonth: this.formatDateTime(
            this.$baseLodash.toString(data.workYm),
            this.$const.dateFormatYYYYMMDD
          ),
          day: data?.workPlanDateDay,
          startTime: this.formatTimeMsel(data?.workPlanStartTime, 'HH:mm'),
          endTime: this.formatTimeMsel(data?.workPlanEndTime, 'HH:mm'),
        }
        this.$refs.fixedTime.setParamsData(cloneData)
      },
      getChangeStatusList() {
        setTimeout(() => {
          let options = this.$refs.changeStatusSelect.options
          let extentList = [this.$divisions.wparStatusEnum.enum_blank.value]
          let list = options.filter((item) => !extentList.includes(item.value))
          this.$refs.changeStatusSelect.options = list
        }, 0)
      },
    },
  }
</script>

<style lang="scss" scoped>
  ::v-deep {
    .btnname {
      font-weight: 500;
    }
  }
</style>
